import React from 'react';
import PropTypes from 'prop-types';
import { SubmissionError } from 'redux-form';
import { API_METHODS } from 'config/constants';
import { getAxios } from 'utils/api/axiosClient';
import { getReduxFormError } from 'utils/forms/getReduxFormError';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { changeAuthProcessingState } from 'store/actions/auth.actions';
import { ForgotPasswordForm } from './ForgotPasswordForm';
import Congratulation from './Congratulation';

@connect(
  ({ authState }) => ({
    authState,
  }),
  (dispatch) => ({
    changeAuthProcessingState: bindActionCreators(
      changeAuthProcessingState,
      dispatch,
    ),
  }),
)
export default class ForgotPasswordPage extends React.PureComponent {
  static propTypes = {
    authState: PropTypes.object,
    changeAuthProcessingState: PropTypes.func,
  };

  state = {
    isShowCongratulation: false,
  };

  handleSubmit = async (values) => {
    const { changeAuthProcessingState } = this.props;
    const axios = getAxios();

    changeAuthProcessingState(true);
    const response = await axios.post(API_METHODS.USER_FORGOT_PASSWORD, values);
    changeAuthProcessingState(false);

    if (!response || response.code !== 'success') {
      throw new SubmissionError(getReduxFormError(response));
    }

    this.setState({ isShowCongratulation: true });
  };

  render() {
    const { isShowCongratulation } = this.state;

    if (isShowCongratulation) {
      return <Congratulation />;
    }

    const { authState } = this.props;
    const { isAuthProcessed } = authState;

    return (
      <ForgotPasswordForm
        isFormProcessed={isAuthProcessed}
        onSubmit={this.handleSubmit}
      />
    );
  }
}
